import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BackButton, TextareaWithLabel } from "../../../components/micro";
import { headChat } from "../../../assets/image";
import ReactSelect from "react-select";
import { Info } from "../../../assets/svg/AllSvg";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { businessActivities } from "../../../redux/companies/slice";
import { InputError } from "../../../commons/MicroComponents";
import { createServicesRequest } from "../../../redux/serviceRequest/slice";

const ChangeBusinessActivity = () => {
  const [businessActivitiesArray, setBusinessActivitiesArray] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  // Selector
  const {
    businessActivitiesData,
    businessActivitiesLoading,
    createServicesRequestData,
    createServicesRequestLoading,
  } = useSelector((store) => ({
    // Business Activities Data
    businessActivitiesData:
      store?.companiesData?.businessActivitiesStatus?.data,
    businessActivitiesLoading:
      store?.companiesData?.businessActivitiesStatus?.loading,
    // createServicesRequestData
    createServicesRequestData:
      store?.serviceRequestData?.createServicesRequestStatus?.data,
    createServicesRequestLoading: store?.serviceRequestData?.loading,
  }));

  // Get APIs
  useEffect(() => {
    dispatch(businessActivities());
  }, [dispatch]);

  // Set Dropdown Options
  useEffect(() => {
    if (businessActivitiesData?.data) {
      let data = businessActivitiesData?.data?.map((x) => ({
        ...x,
        label: x.full_activity,
      }));
      setBusinessActivitiesArray(data);
    }
  }, [businessActivitiesData]);

  const handleProceed = (value) => {
    const payload = {
      details: {
        describe_primary_activity: value.describe_primary_activity,
        describe_secondary_activity: value.describe_secondary_activity,
        primary_activity: value.primary_activity.id,
        secondary_activity: value.secondary_activity.id,
      },
      amount:
        service?.service_requests_count < service?.detail?.no_of_free_request
          ? 0
          : service?.detail?.price,
      user_id: user_id,
      company_id: company_id,
      service_id: service?.id,
    };
    dispatch(createServicesRequest(payload)).then((res) => {
      if (res.type !== "createServicesRequest/fulfilled") return;
      const { service_requests_count, detail } = service || {};
      const price = detail?.price || 0;
      if (
        service_requests_count < service?.detail?.no_of_free_request ||
        price <= 0
      ) {
        navigate("/approver");
      } else if (buttonRef.current) {
        buttonRef.current.click();
      } else {
        navigate("/approver");
      }
    });
  };

  return (
    <>
      <div className="space-y-5">
        <BackButton
          onClick={() => {
            navigate("/service");
          }}
        />
        <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
          <img src={headChat} alt="img" />
          <div className="space-y-2 font-ebGaramond">
            <p className="text-xl">We see that you will need a request on:</p>
            <p className="text-3xl">Change of Business Activity </p>
          </div>
        </div>
        {/* Payment Button */}
        <a
          className="hidden"
          ref={buttonRef}
          href={createServicesRequestData?.data?.url}
        >
          Pay Now
        </a>
        <Formik
          enableReinitialize={true}
          initialValues={{
            primary_activity: "",
            describe_primary_activity: "",
            secondary_activity: "",
            describe_secondary_activity: "",
          }}
          validationSchema={Yup.object({
            primary_activity: Yup.object().required(
              "Please Select Primary Activity"
            ),
            describe_primary_activity: Yup.string().required(
              "Please Describe your Primary Activity"
            ),
            secondary_activity: Yup.object().required(
              "Please Select Secondary Activity"
            ),
            describe_secondary_activity: Yup.string().required(
              "Please Describe your Secondary Activity"
            ),
          })}
          onSubmit={handleProceed}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            setFieldValue,
            handleChange,
          }) => (
            <Form className="space-y-5">
              <div className="border-b-2 border-secondary_grey pb-5">
                <p className="text-2xl font-ebGaramond">
                  Once the request is opened. You can easily manage it over at
                  “On-Going” service page.
                </p>
              </div>
              <div className="space-y-3 border-b-2 border-secondary_grey pb-3">
                <p className="text-2xl font-ebGaramond">
                  Let us guide u though the process:
                </p>
                <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                  <span>1.</span>
                  <p>Check if the New Company Name is available</p>
                </div>
                <p className="text-lg">Re-Classify your company</p>
                <p className="text-sm">
                  Singapore Standard Industrial Classification (SSIC) code for
                  your business
                </p>
                <button className="text-theme border-b border-theme">
                  Quick Guide
                </button>
                {/* SSIC - Company Primary Activity */}
                <div>
                  <ReactSelect
                    className={"text-black sm:text-base text-sm p-0"}
                    id="primary_activity"
                    placeholder="SSIC - Company Primary Activity"
                    options={businessActivitiesArray}
                    isLoading={businessActivitiesLoading}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.id}
                    value={values.primary_activity}
                    onChange={(e) => {
                      setFieldValue("primary_activity", e);
                    }}
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: `1px solid ${
                          errors.primary_activity && touched.primary_activity
                            ? "red"
                            : "#0000003B"
                        }`,
                        borderRadius: "0.25rem",
                        padding: "6px 4px",
                        boxShadow: "none",
                        "&:hover": {
                          border: "1px solid #0000003B",
                        },
                      }),
                    }}
                  />
                  {errors.primary_activity && touched.primary_activity ? (
                    <InputError errorTitle={errors.primary_activity} />
                  ) : null}
                </div>
                {/* Describe Primary Activity */}
                <TextareaWithLabel
                  className={
                    errors.describe_primary_activity &&
                    touched.describe_primary_activity
                      ? ` input-error `
                      : ` border `
                  }
                  idFromName="describe_primary_activity"
                  label="Please describe your Primary activity"
                  type="text"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.describe_primary_activity}
                  errors={
                    errors.describe_primary_activity &&
                    touched.describe_primary_activity
                  }
                  errorsText={errors.describe_primary_activity}
                />
                {/* SSIC - Company Secondary Activity */}
                <ReactSelect
                  className={"text-black sm:text-base text-sm p-0"}
                  id="secondary_activity"
                  placeholder="SSIC - Company Secondary Activity"
                  options={businessActivitiesArray}
                  isLoading={businessActivitiesLoading}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.id}
                  value={values.secondary_activity}
                  onChange={(e) => {
                    setFieldValue("secondary_activity", e);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: `1px solid ${
                        errors.secondary_activity && touched.secondary_activity
                          ? "red"
                          : "#0000003B"
                      }`,
                      borderRadius: "0.25rem",
                      padding: "6px 4px",
                      boxShadow: "none",
                      "&:hover": {
                        border: "1px solid #0000003B",
                      },
                    }),
                  }}
                />
                {errors.secondary_activity && touched.secondary_activity ? (
                  <InputError errorTitle={errors.secondary_activity} />
                ) : null}
                {/* Describe Secondary Activity */}
                <TextareaWithLabel
                  className={
                    errors.describe_secondary_activity &&
                    touched.describe_secondary_activity
                      ? ` input-error `
                      : ` border `
                  }
                  idFromName="describe_secondary_activity"
                  label="Please describe your Secondary activity"
                  type="text"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.describe_secondary_activity}
                  errors={
                    errors.describe_secondary_activity &&
                    touched.describe_secondary_activity
                  }
                  errorsText={errors.describe_secondary_activity}
                />
                <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                  <span>2.</span>
                  <p>We will prepare relevant resolution</p>
                </div>
                <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                  <span>3.</span>
                  <p>Obtain signed resolution</p>
                </div>
                <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                  <span>4.</span>
                  <p>
                    We will lodge the changes to ACRA for the change of Company
                    Name
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between space-x-1  bg-light_primary_shades rounded-lg px-4 py-3">
                <p className="font-semibold flex items-center">
                  <Info className="mr-3" />
                  Total Payable :
                </p>
                <div className="flex items-center space-x-7">
                  <p className="text-xs text-gray-400">
                    {service?.service_requests_count}/
                    {service?.detail?.no_of_free_request ?? 0} used
                  </p>
                  <div>
                    <p className="text-xs">
                      {service?.service_requests_count}/
                      {service?.detail?.no_of_free_request ?? 0} used
                    </p>
                    <p>
                      {service?.service_requests_count >=
                      service?.detail?.no_of_free_request
                        ? `$${service?.detail?.price}`
                        : "Free"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="box !rounded-xl flex items-center justify-between">
                <button
                  type="submit"
                  className={`${
                    createServicesRequestLoading
                      ? "btn-outline-disabled"
                      : "btn-theme"
                  } uppercase`}
                  disabled={createServicesRequestLoading}
                >
                  {createServicesRequestLoading
                    ? "Loading..."
                    : "Proceed with request"}
                </button>
                <div>
                  <p className="text-xs">Total:</p>
                  <p>
                    $
                    {service?.service_requests_count >=
                    service?.detail?.no_of_free_request
                      ? `$${service?.detail?.price}`
                      : "Free"}
                  </p>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default ChangeBusinessActivity;
